import { render, staticRenderFns } from "./ShopMenuBookCollectionsFilter.vue?vue&type=template&id=7bc16d94&scoped=true&"
import script from "./ShopMenuBookCollectionsFilter.vue?vue&type=script&lang=js&"
export * from "./ShopMenuBookCollectionsFilter.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuBookCollectionsFilter.vue?vue&type=style&index=0&id=7bc16d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc16d94",
  null
  
)

export default component.exports